var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7656 0.764314C12.7656 0.34237 13.108 1.33812e-05 13.5299 0C15.2598 0 16.9187 0.687679 18.1418 1.91079C19.3649 3.13394 20.0516 4.79299 20.0516 6.52266C20.0516 6.94461 19.7102 7.28697 19.2873 7.28697H13.5299C13.108 7.28697 12.7656 6.94461 12.7656 6.52266V0.764314ZM10.1402 9.83494H18.0381V9.83519C18.46 9.83519 18.8024 10.1776 18.8024 10.5995C18.8024 13.0914 17.8131 15.4809 16.0516 17.2434C14.2912 19.0069 11.9017 19.9981 9.40974 20.0001C6.91782 20.0021 4.52725 19.0159 2.76275 17.2554C0.998207 15.4957 0.00498855 13.1083 1.26101e-05 10.6163C-0.00406373 8.12415 0.980296 5.73276 2.73881 3.96628C4.49647 2.20084 6.88388 1.20464 9.37586 1.19768C9.79781 1.19768 10.1402 1.54004 10.1402 1.96199V9.83494Z",
    fill: "url(#paint0_linear_553_24236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_553_24236",
    x1: 0,
    y1: 10,
    x2: 20.0516,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AA04"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.d98704a5f466eca89817c2a00fb9ec91.svg";
export { ForwardRef as ReactComponent };